<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/stock/transfers">{{ $t('stock_transfer') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('branch_from') }}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.FromBranchId">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('branch_to') }}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.ToBranchId">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('date') }}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.Date" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('remark') }}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="header.Remark" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                    <tr class="blue">
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 120px;">{{$t('qty')}}</th>
                                        <th style="width: 20px;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="index">
                                        <td><AuthCompleted @select="select($event, ret)" :value="ret.ItemName"></AuthCompleted></td>
                                        <td>
                                            <input type="text" class="form-control form-control-sm" v-model="ret.Description" />
                                        </td>
                                        <td class="text-center">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Quantity">
                                        </td>
                                        <td class="text-right"><a href="javascript:void(0)" class="red" @click="removeLine(index)"><i aria-hidden="true" class="fa fa-times-circle"></i></a></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td class="none-left">
                                            <button type="button"
                                                    class="btn btn-outline-primary btn-sm no-bor"
                                                    @click="addLine">
                                                <i class="fa fa-plus"/>
                                                {{ $t('add_line') }}
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    export default {
        components: {
            AuthCompleted,
        },
        data: function(){
            return {
                branchs: [],
                header: {
                    FromBranchId: '',
                    ToBranchId: '',
                    Date: this.$now().format('YYYY-MM-DD')
                },
                lines: [
                    {
                        ItemId: '',
                        ItemName: '',
                        Description: '',
                        Quantity: 1
                    }
                ]
            }
        },
        created(){
            this.branchList();
            let id = this.$route.params.id;
            if(id != undefined && id != ''){
                this.findById(id);
            }
        },
        methods: {
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('stock/transfer/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.header = res.data.Json.Header;
                        this.lines = res.data.Json.Lines;
                    }
                }).finally(function(){ loading.hide(); });
            },
            branchList(){
                this.$api().post('branch/list', { Limit: 0 }).then(res => {
                    if(this.$isValid(res)){
                        this.branchs = res.data.Data;
                    }
                });
            },
            save(){
                var loading = this.$loading.show();
                var req = {
                    Header: this.header,
                    Lines: this.lines
                }
                this.$api().post('stock/transfer/save', req).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/stock/transfers');
                    }
                }).finally(() => { loading.hide()});
            },
            select(e, item){
                item.ItemId = e.Id;
                item.ItemName = e.Name;
            },
            addLine(){
                this.lines.push({
                    ItemId: '',
                    ItemName: '',
                    Description: '',
                    Quantity: 1
                });
            },
            removeLine(index){
                if(this.lines.length > 1){
                    this.lines.splice(index, 1);
                }
            }
        }
    }
</script>
